const readable = {
	name: 'Read confirmation | Read confirmations',
	icon: '',
	fields: {
		user_fullname: 'Name',
		user_email: 'Email',
		read_on: 'Read on',
	},
}

export default readable
